import request from "@utils/request";

export function getConfig(id) {
  return request.get("/lottery/getconfig/" + id);
}

export function getLuckPrize(id) {
  return request.get("/lottery/getluckprize/" + id);
}

export function getLuckHistory(data) {
  return request.get("/lottery/getluckhistory", data);
}